import { Link } from "@/components";
import { Typography } from "antd";
import styled from "styled-components";

const { Title, Text } = Typography;

export const CardStatistic = styled(Title)`
  &.ant-typography {
    color: #db011c;
  }
  display: inline;
`;

export const StyledLinkTitle = styled(Link)`
  padding-left: 1rem;
  display: inline;
  font-size: 1.2rem;
`;

export const StyledTitle = styled(Text)`
  padding-left: 1rem;
  display: inline;
  font-size: 1.2rem;
`;
